/* eslint-disable max-len */
import React from "react";
import styled, { withTheme } from "styled-components";

const Svg = styled.svg.attrs(() => ({
  x: 0,
  y: 0,
  viewBox: "0 0 32 32",
}))`
  fill: ${({ theme: { palette } }) => palette.error};
  width: 2rem;
`;

const PathOne = styled.path.attrs(() => ({
  // eslint-disable-next-line id-length
  d:
    "M15.97,22.282c-0.361,0-0.67,0.125-0.92,0.373c-0.248,0.252-0.375,0.554-0.375,0.909c0,0.408,0.13,0.73,0.39,0.953" +
    "c0.261,0.228,0.57,0.343,0.917,0.343c0.349,0,0.651-0.115,0.908-0.344c0.259-0.231,0.387-0.547,0.387-0.952" +
    "c0-0.355-0.128-0.657-0.378-0.909C16.638,22.407,16.331,22.282,15.97,22.282z",
}))``;

const PathTwo = styled.path.attrs(() => ({
  // eslint-disable-next-line id-length
  d:
    "M14.675,13.878c0,0.353,0.026,0.931,0.078,1.733l0.276,2.888c0.052,0.534,0.139,0.93,0.261,1.194" +
    "c0.117,0.261,0.333,0.391,0.645,0.391c0.302,0,0.523-0.134,0.656-0.405c0.131-0.271,0.218-0.66,0.257-1.165l0.372-3.008" +
    "c0.043-0.388,0.057-0.774,0.057-1.152c0-0.646-0.079-1.139-0.248-1.483c-0.167-0.34-0.5-0.513-0.99-0.513" +
    "c-0.411,0-0.739,0.135-0.989,0.402C14.802,13.027,14.675,13.401,14.675,13.878z",
}))``;

const PathThree = styled.path.attrs(() => ({
  // eslint-disable-next-line id-length
  d:
    "M31.843,28.477l-15-26c-0.357-0.619-1.375-0.619-1.732,0l-15,26c-0.179,0.31-0.178,0.69,0,1" +
    "c0.178,0.31,0.508,0.5,0.866,0.5h30c0.357,0,0.688-0.19,0.866-0.5S32.022,28.786,31.843,28.477z M2.708,27.977L15.977,4.978" +
    "l13.269,22.999H2.708z",
}))``;

export const InitialErrorComponent = (props: unknown) => {
  return (
    <Svg {...props}>
      <g>
        <PathOne />
        <PathTwo />
        <PathThree />
      </g>
    </Svg>
  );
};

export const Error = withTheme(InitialErrorComponent);
